import { EmptyState, Flex, Heading, Icons, Paragraph } from "@ir/ui";

const InternalConversationEmpty = () => {
  return (
    <Flex align="center" justifyContent="center" style={{ height: "100%" }}>
      <EmptyState
        className="bg-white py-5 w-100"
        icon={Icons.MessageChatCircle}
        title={
          <Heading level={6} className="text-grey-700 font-bold mt-3">
            No Conversation(s) Found
          </Heading>
        }
        description={<Paragraph className="text-grey-500 font-regular mb-0">This is where you can view all your Conversation(s)</Paragraph>}
      />
    </Flex>
  );
};

export default InternalConversationEmpty;
